// extracted by mini-css-extract-plugin
module.exports = {"Title":"TestSection_Title__AuSiu"};